// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/message_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import type { CallContext, CallOptions } from "nice-grpc-common";
import { Empty } from "../../../google/protobuf/empty.js";
import { Timestamp } from "../../../google/protobuf/timestamp.js";
import {
  AttachmentRef,
  EmbeddedMedia,
  Message,
  MessageChangeEvent,
  MessagePart,
  MessageReaction,
  ReplyTarget,
  StickerPlacement,
  TextFormat,
} from "./message_types.js";
import { Heartbeat } from "./streaming.js";

export const protobufPackage = "photon.imessage.v1";

export interface MessageTarget {
  chatGuid: string;
  messageGuid: string;
  /**
   * Selects a single bubble in a multipart message. Absent = the whole
   * message root.
   */
  targetPartIndex?: number | undefined;
}

/**
 * Plain-text or rich-text send.
 *
 * `enable_data_detection` enables Apple's data-detector pass.
 * `enable_link_preview` enables URL-preview generation.
 */
export interface SendTextMessageRequest {
  chatGuid: string;
  text: string;
  replyTo?: ReplyTarget | undefined;
  subject?: string | undefined;
  effectId?: string | undefined;
  enableDataDetection?: boolean | undefined;
  enableLinkPreview?: boolean | undefined;
  formatting: TextFormat[];
  clientMessageId?: string | undefined;
}

/**
 * Single-attachment send. The attachment is referenced either by GUID
 * (already uploaded via `AttachmentService.UploadAttachment`) or by an
 * absolute filesystem path readable by the local mutation process.
 */
export interface SendAttachmentMessageRequest {
  chatGuid: string;
  attachment: AttachmentRef | undefined;
  replyTo?: ReplyTarget | undefined;
  effectId?: string | undefined;
  isAudioMessage?: boolean | undefined;
  clientMessageId?: string | undefined;
}

/** Multipart send: multiple bubbles delivered atomically. */
export interface SendMultipartMessageRequest {
  chatGuid: string;
  parts: MessagePart[];
  replyTo?: ReplyTarget | undefined;
  subject?: string | undefined;
  effectId?: string | undefined;
  enableDataDetection?: boolean | undefined;
  clientMessageId?: string | undefined;
}

/**
 * Sends a mini app card.
 *
 * Recipients open `url` when they tap the card. The caller supplies every
 * visible preview field; the mini app host identity is server-managed.
 */
export interface SendMiniAppMessageRequest {
  /** Target chat GUID. */
  chatGuid: string;
  /** Absolute HTTP or HTTPS URL opened from the card. */
  url: string;
  preview: MiniAppPreview | undefined;
  clientMessageId?: string | undefined;
}

export interface MiniAppPreview {
  /** Main title shown on the card. */
  title: string;
  /** Secondary text for the card template. */
  subtitle?:
    | string
    | undefined;
  /** Supporting body text for the card template. */
  body?:
    | string
    | undefined;
  /** JPEG preview image bytes. */
  imageJpeg?:
    | Uint8Array
    | undefined;
  /** Small label shown by the card template. */
  caption?:
    | string
    | undefined;
  /** Secondary label shown by the card template. */
  footer?:
    | string
    | undefined;
  /** Additional detail label shown by the card template. */
  detail?:
    | string
    | undefined;
  /** Fallback text for surfaces that cannot render the full card. */
  summary?: string | undefined;
}

/**
 * Visible content of a customized mini-app card. Field names match Apple's
 * `MSMessageTemplateLayout` public API so callers do not need to translate
 * between our names and Apple's docs.
 *
 * Slot map:
 *   * caption/subcaption render on the left;
 *   * trailing_caption/trailing_subcaption render on the right;
 *   * image_title/image_subtitle overlay the image.
 *
 * Validation enforced by the server:
 *   * at least one of {caption, subcaption, trailing_caption,
 *     trailing_subcaption, image} must be non-empty; otherwise the
 *     recipient would see an empty bubble;
 *   * `image` and `image_title` must be set together;
 *   * `image_subtitle` requires `image`.
 */
export interface MiniAppLayout {
  /** Top-left, bold. The most prominent text slot. */
  caption?:
    | string
    | undefined;
  /** Below `caption`, on the left. */
  subcaption?:
    | string
    | undefined;
  /** Top-right. */
  trailingCaption?:
    | string
    | undefined;
  /** Below `trailing_caption`, on the right. */
  trailingSubcaption?:
    | string
    | undefined;
  /** JPEG preview image bytes. Server validates the JPEG SOI marker. */
  image?:
    | Uint8Array
    | undefined;
  /** Overlay text shown above the image. Must be set together with `image`. */
  imageTitle?:
    | string
    | undefined;
  /**
   * Overlay text shown below `image_title`, above the image edge.
   * Requires `image`.
   */
  imageSubtitle?:
    | string
    | undefined;
  /** Fallback text shown on surfaces that cannot render the full card. */
  summary?: string | undefined;
}

/** Request for `SendCustomizedMiniAppMessage`. */
export interface SendCustomizedMiniAppMessageRequest {
  /** Target chat GUID. */
  chatGuid: string;
  /** 10-character uppercase alphanumeric Apple Team ID. */
  teamId: string;
  /** Bundle identifier of the iMessage extension target. */
  extensionBundleId: string;
  /** Human-readable name of the owning app. */
  appName: string;
  /** Absolute URL the recipient's installed extension receives on tap. */
  url: string;
  /**
   * The visible layout of the card. Mirrors Apple's
   * `MSMessageTemplateLayout`; see `MiniAppLayout` for the rendering map.
   */
  layout:
    | MiniAppLayout
    | undefined;
  /** Apple App Store numeric id of the owning app. When set, must be > 0. */
  appStoreId?: number | undefined;
  clientMessageId?: string | undefined;
}

export interface MessageResponse {
  /**
   * Snapshot of the persisted message after Apple has accepted the send
   * and chat.db has been observed.
   */
  message: Message | undefined;
}

export interface EditMessageRequest {
  target: MessageTarget | undefined;
  newText: string;
  /**
   * Plain-text fallback for recipients on older clients that cannot
   * render rich edits. Absent = derive from `new_text`.
   */
  backwardCompatText?: string | undefined;
  clientMessageId?: string | undefined;
}

export interface UnsendMessageRequest {
  target: MessageTarget | undefined;
  clientMessageId?: string | undefined;
}

export interface SetReactionRequest {
  target: MessageTarget | undefined;
  reaction:
    | MessageReaction
    | undefined;
  /**
   * `true` adds or replaces the caller's reaction of this kind on the target.
   * `false` removes it.
   */
  isSet: boolean;
  clientMessageId?: string | undefined;
}

export interface PlaceStickerRequest {
  target: MessageTarget | undefined;
  sticker: AttachmentRef | undefined;
  placement: StickerPlacement | undefined;
  clientMessageId?: string | undefined;
}

export interface NotifySilencedMessageRequest {
  chatGuid: string;
  messageGuid: string;
  clientMessageId?: string | undefined;
}

export interface GetMessageRequest {
  messageGuid: string;
}

export interface GetMessageResponse {
  message: Message | undefined;
}

/**
 * Pages across the caller's recent message history.
 *
 * Filters compose with AND semantics. `before` / `after` define a half-open window:
 * `[after, before)`.
 */
export interface ListRecentMessagesRequest {
  pageSize?: number | undefined;
  pageToken?: string | undefined;
  isFromMe?: boolean | undefined;
  isRead?: boolean | undefined;
  before?: Date | undefined;
  after?: Date | undefined;
}

export interface ListRecentMessagesResponse {
  messages: Message[];
  nextPageToken?: string | undefined;
}

/** As `ListRecentMessages` but constrained to one chat. */
export interface ListChatMessagesRequest {
  chatGuid: string;
  pageSize?: number | undefined;
  pageToken?: string | undefined;
  isFromMe?: boolean | undefined;
  isRead?: boolean | undefined;
  before?: Date | undefined;
  after?: Date | undefined;
}

export interface ListChatMessagesResponse {
  messages: Message[];
  nextPageToken?: string | undefined;
}

export interface GetEmbeddedMediaRequest {
  chatGuid: string;
  messageGuid: string;
}

export interface GetEmbeddedMediaResponse {
  media: EmbeddedMedia | undefined;
}

export interface SubscribeMessageEventsRequest {
  /** Absent = subscribe to every chat the caller can observe. */
  chatGuid?: string | undefined;
}

export interface SubscribeMessageEventsResponse {
  /**
   * Monotonic global sequence; absent on heartbeat frames. Shared with
   * `EventService.CatchUpEvents` and every other `Subscribe*` stream.
   */
  sequence?: number | undefined;
  messageChanged?: MessageChangeEvent | undefined;
  heartbeat?: Heartbeat | undefined;
}

function createBaseMessageTarget(): MessageTarget {
  return { chatGuid: "", messageGuid: "", targetPartIndex: undefined };
}

export const MessageTarget: MessageFns<MessageTarget> = {
  encode(message: MessageTarget, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.messageGuid !== "") {
      writer.uint32(18).string(message.messageGuid);
    }
    if (message.targetPartIndex !== undefined) {
      writer.uint32(24).int32(message.targetPartIndex);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageTarget {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageTarget();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messageGuid = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.targetPartIndex = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageTarget {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      messageGuid: isSet(object.messageGuid)
        ? globalThis.String(object.messageGuid)
        : isSet(object.message_guid)
        ? globalThis.String(object.message_guid)
        : "",
      targetPartIndex: isSet(object.targetPartIndex)
        ? globalThis.Number(object.targetPartIndex)
        : isSet(object.target_part_index)
        ? globalThis.Number(object.target_part_index)
        : undefined,
    };
  },

  toJSON(message: MessageTarget): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.messageGuid !== "") {
      obj.messageGuid = message.messageGuid;
    }
    if (message.targetPartIndex !== undefined) {
      obj.targetPartIndex = Math.round(message.targetPartIndex);
    }
    return obj;
  },

  create(base?: DeepPartial<MessageTarget>): MessageTarget {
    return MessageTarget.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageTarget>): MessageTarget {
    const message = createBaseMessageTarget();
    message.chatGuid = object.chatGuid ?? "";
    message.messageGuid = object.messageGuid ?? "";
    message.targetPartIndex = object.targetPartIndex ?? undefined;
    return message;
  },
};

function createBaseSendTextMessageRequest(): SendTextMessageRequest {
  return {
    chatGuid: "",
    text: "",
    replyTo: undefined,
    subject: undefined,
    effectId: undefined,
    enableDataDetection: undefined,
    enableLinkPreview: undefined,
    formatting: [],
    clientMessageId: undefined,
  };
}

export const SendTextMessageRequest: MessageFns<SendTextMessageRequest> = {
  encode(message: SendTextMessageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.text !== "") {
      writer.uint32(18).string(message.text);
    }
    if (message.replyTo !== undefined) {
      ReplyTarget.encode(message.replyTo, writer.uint32(26).fork()).join();
    }
    if (message.subject !== undefined) {
      writer.uint32(34).string(message.subject);
    }
    if (message.effectId !== undefined) {
      writer.uint32(42).string(message.effectId);
    }
    if (message.enableDataDetection !== undefined) {
      writer.uint32(48).bool(message.enableDataDetection);
    }
    if (message.enableLinkPreview !== undefined) {
      writer.uint32(56).bool(message.enableLinkPreview);
    }
    for (const v of message.formatting) {
      TextFormat.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendTextMessageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendTextMessageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.replyTo = ReplyTarget.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.subject = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.effectId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enableDataDetection = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.enableLinkPreview = reader.bool();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.formatting.push(TextFormat.decode(reader, reader.uint32()));
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendTextMessageRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      replyTo: isSet(object.replyTo)
        ? ReplyTarget.fromJSON(object.replyTo)
        : isSet(object.reply_to)
        ? ReplyTarget.fromJSON(object.reply_to)
        : undefined,
      subject: isSet(object.subject) ? globalThis.String(object.subject) : undefined,
      effectId: isSet(object.effectId)
        ? globalThis.String(object.effectId)
        : isSet(object.effect_id)
        ? globalThis.String(object.effect_id)
        : undefined,
      enableDataDetection: isSet(object.enableDataDetection)
        ? globalThis.Boolean(object.enableDataDetection)
        : isSet(object.enable_data_detection)
        ? globalThis.Boolean(object.enable_data_detection)
        : undefined,
      enableLinkPreview: isSet(object.enableLinkPreview)
        ? globalThis.Boolean(object.enableLinkPreview)
        : isSet(object.enable_link_preview)
        ? globalThis.Boolean(object.enable_link_preview)
        : undefined,
      formatting: globalThis.Array.isArray(object?.formatting)
        ? object.formatting.map((e: any) => TextFormat.fromJSON(e))
        : [],
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: SendTextMessageRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.replyTo !== undefined) {
      obj.replyTo = ReplyTarget.toJSON(message.replyTo);
    }
    if (message.subject !== undefined) {
      obj.subject = message.subject;
    }
    if (message.effectId !== undefined) {
      obj.effectId = message.effectId;
    }
    if (message.enableDataDetection !== undefined) {
      obj.enableDataDetection = message.enableDataDetection;
    }
    if (message.enableLinkPreview !== undefined) {
      obj.enableLinkPreview = message.enableLinkPreview;
    }
    if (message.formatting?.length) {
      obj.formatting = message.formatting.map((e) => TextFormat.toJSON(e));
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<SendTextMessageRequest>): SendTextMessageRequest {
    return SendTextMessageRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SendTextMessageRequest>): SendTextMessageRequest {
    const message = createBaseSendTextMessageRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.text = object.text ?? "";
    message.replyTo = (object.replyTo !== undefined && object.replyTo !== null)
      ? ReplyTarget.fromPartial(object.replyTo)
      : undefined;
    message.subject = object.subject ?? undefined;
    message.effectId = object.effectId ?? undefined;
    message.enableDataDetection = object.enableDataDetection ?? undefined;
    message.enableLinkPreview = object.enableLinkPreview ?? undefined;
    message.formatting = object.formatting?.map((e) => TextFormat.fromPartial(e)) || [];
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseSendAttachmentMessageRequest(): SendAttachmentMessageRequest {
  return {
    chatGuid: "",
    attachment: undefined,
    replyTo: undefined,
    effectId: undefined,
    isAudioMessage: undefined,
    clientMessageId: undefined,
  };
}

export const SendAttachmentMessageRequest: MessageFns<SendAttachmentMessageRequest> = {
  encode(message: SendAttachmentMessageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.attachment !== undefined) {
      AttachmentRef.encode(message.attachment, writer.uint32(18).fork()).join();
    }
    if (message.replyTo !== undefined) {
      ReplyTarget.encode(message.replyTo, writer.uint32(26).fork()).join();
    }
    if (message.effectId !== undefined) {
      writer.uint32(34).string(message.effectId);
    }
    if (message.isAudioMessage !== undefined) {
      writer.uint32(40).bool(message.isAudioMessage);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendAttachmentMessageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendAttachmentMessageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.attachment = AttachmentRef.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.replyTo = ReplyTarget.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.effectId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isAudioMessage = reader.bool();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendAttachmentMessageRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      attachment: isSet(object.attachment) ? AttachmentRef.fromJSON(object.attachment) : undefined,
      replyTo: isSet(object.replyTo)
        ? ReplyTarget.fromJSON(object.replyTo)
        : isSet(object.reply_to)
        ? ReplyTarget.fromJSON(object.reply_to)
        : undefined,
      effectId: isSet(object.effectId)
        ? globalThis.String(object.effectId)
        : isSet(object.effect_id)
        ? globalThis.String(object.effect_id)
        : undefined,
      isAudioMessage: isSet(object.isAudioMessage)
        ? globalThis.Boolean(object.isAudioMessage)
        : isSet(object.is_audio_message)
        ? globalThis.Boolean(object.is_audio_message)
        : undefined,
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: SendAttachmentMessageRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.attachment !== undefined) {
      obj.attachment = AttachmentRef.toJSON(message.attachment);
    }
    if (message.replyTo !== undefined) {
      obj.replyTo = ReplyTarget.toJSON(message.replyTo);
    }
    if (message.effectId !== undefined) {
      obj.effectId = message.effectId;
    }
    if (message.isAudioMessage !== undefined) {
      obj.isAudioMessage = message.isAudioMessage;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<SendAttachmentMessageRequest>): SendAttachmentMessageRequest {
    return SendAttachmentMessageRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SendAttachmentMessageRequest>): SendAttachmentMessageRequest {
    const message = createBaseSendAttachmentMessageRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.attachment = (object.attachment !== undefined && object.attachment !== null)
      ? AttachmentRef.fromPartial(object.attachment)
      : undefined;
    message.replyTo = (object.replyTo !== undefined && object.replyTo !== null)
      ? ReplyTarget.fromPartial(object.replyTo)
      : undefined;
    message.effectId = object.effectId ?? undefined;
    message.isAudioMessage = object.isAudioMessage ?? undefined;
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseSendMultipartMessageRequest(): SendMultipartMessageRequest {
  return {
    chatGuid: "",
    parts: [],
    replyTo: undefined,
    subject: undefined,
    effectId: undefined,
    enableDataDetection: undefined,
    clientMessageId: undefined,
  };
}

export const SendMultipartMessageRequest: MessageFns<SendMultipartMessageRequest> = {
  encode(message: SendMultipartMessageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    for (const v of message.parts) {
      MessagePart.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.replyTo !== undefined) {
      ReplyTarget.encode(message.replyTo, writer.uint32(26).fork()).join();
    }
    if (message.subject !== undefined) {
      writer.uint32(34).string(message.subject);
    }
    if (message.effectId !== undefined) {
      writer.uint32(42).string(message.effectId);
    }
    if (message.enableDataDetection !== undefined) {
      writer.uint32(48).bool(message.enableDataDetection);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendMultipartMessageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendMultipartMessageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.parts.push(MessagePart.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.replyTo = ReplyTarget.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.subject = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.effectId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.enableDataDetection = reader.bool();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendMultipartMessageRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      parts: globalThis.Array.isArray(object?.parts) ? object.parts.map((e: any) => MessagePart.fromJSON(e)) : [],
      replyTo: isSet(object.replyTo)
        ? ReplyTarget.fromJSON(object.replyTo)
        : isSet(object.reply_to)
        ? ReplyTarget.fromJSON(object.reply_to)
        : undefined,
      subject: isSet(object.subject) ? globalThis.String(object.subject) : undefined,
      effectId: isSet(object.effectId)
        ? globalThis.String(object.effectId)
        : isSet(object.effect_id)
        ? globalThis.String(object.effect_id)
        : undefined,
      enableDataDetection: isSet(object.enableDataDetection)
        ? globalThis.Boolean(object.enableDataDetection)
        : isSet(object.enable_data_detection)
        ? globalThis.Boolean(object.enable_data_detection)
        : undefined,
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: SendMultipartMessageRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.parts?.length) {
      obj.parts = message.parts.map((e) => MessagePart.toJSON(e));
    }
    if (message.replyTo !== undefined) {
      obj.replyTo = ReplyTarget.toJSON(message.replyTo);
    }
    if (message.subject !== undefined) {
      obj.subject = message.subject;
    }
    if (message.effectId !== undefined) {
      obj.effectId = message.effectId;
    }
    if (message.enableDataDetection !== undefined) {
      obj.enableDataDetection = message.enableDataDetection;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<SendMultipartMessageRequest>): SendMultipartMessageRequest {
    return SendMultipartMessageRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SendMultipartMessageRequest>): SendMultipartMessageRequest {
    const message = createBaseSendMultipartMessageRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.parts = object.parts?.map((e) => MessagePart.fromPartial(e)) || [];
    message.replyTo = (object.replyTo !== undefined && object.replyTo !== null)
      ? ReplyTarget.fromPartial(object.replyTo)
      : undefined;
    message.subject = object.subject ?? undefined;
    message.effectId = object.effectId ?? undefined;
    message.enableDataDetection = object.enableDataDetection ?? undefined;
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseSendMiniAppMessageRequest(): SendMiniAppMessageRequest {
  return { chatGuid: "", url: "", preview: undefined, clientMessageId: undefined };
}

export const SendMiniAppMessageRequest: MessageFns<SendMiniAppMessageRequest> = {
  encode(message: SendMiniAppMessageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.url !== "") {
      writer.uint32(18).string(message.url);
    }
    if (message.preview !== undefined) {
      MiniAppPreview.encode(message.preview, writer.uint32(26).fork()).join();
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendMiniAppMessageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendMiniAppMessageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.preview = MiniAppPreview.decode(reader, reader.uint32());
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendMiniAppMessageRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      preview: isSet(object.preview) ? MiniAppPreview.fromJSON(object.preview) : undefined,
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: SendMiniAppMessageRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.preview !== undefined) {
      obj.preview = MiniAppPreview.toJSON(message.preview);
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<SendMiniAppMessageRequest>): SendMiniAppMessageRequest {
    return SendMiniAppMessageRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SendMiniAppMessageRequest>): SendMiniAppMessageRequest {
    const message = createBaseSendMiniAppMessageRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.url = object.url ?? "";
    message.preview = (object.preview !== undefined && object.preview !== null)
      ? MiniAppPreview.fromPartial(object.preview)
      : undefined;
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseMiniAppPreview(): MiniAppPreview {
  return {
    title: "",
    subtitle: undefined,
    body: undefined,
    imageJpeg: undefined,
    caption: undefined,
    footer: undefined,
    detail: undefined,
    summary: undefined,
  };
}

export const MiniAppPreview: MessageFns<MiniAppPreview> = {
  encode(message: MiniAppPreview, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.title !== "") {
      writer.uint32(10).string(message.title);
    }
    if (message.subtitle !== undefined) {
      writer.uint32(18).string(message.subtitle);
    }
    if (message.body !== undefined) {
      writer.uint32(26).string(message.body);
    }
    if (message.imageJpeg !== undefined) {
      writer.uint32(34).bytes(message.imageJpeg);
    }
    if (message.caption !== undefined) {
      writer.uint32(42).string(message.caption);
    }
    if (message.footer !== undefined) {
      writer.uint32(50).string(message.footer);
    }
    if (message.detail !== undefined) {
      writer.uint32(58).string(message.detail);
    }
    if (message.summary !== undefined) {
      writer.uint32(66).string(message.summary);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MiniAppPreview {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMiniAppPreview();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.subtitle = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.body = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.imageJpeg = reader.bytes();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.caption = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.footer = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.detail = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.summary = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MiniAppPreview {
    return {
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      subtitle: isSet(object.subtitle) ? globalThis.String(object.subtitle) : undefined,
      body: isSet(object.body) ? globalThis.String(object.body) : undefined,
      imageJpeg: isSet(object.imageJpeg)
        ? bytesFromBase64(object.imageJpeg)
        : isSet(object.image_jpeg)
        ? bytesFromBase64(object.image_jpeg)
        : undefined,
      caption: isSet(object.caption) ? globalThis.String(object.caption) : undefined,
      footer: isSet(object.footer) ? globalThis.String(object.footer) : undefined,
      detail: isSet(object.detail) ? globalThis.String(object.detail) : undefined,
      summary: isSet(object.summary) ? globalThis.String(object.summary) : undefined,
    };
  },

  toJSON(message: MiniAppPreview): unknown {
    const obj: any = {};
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.subtitle !== undefined) {
      obj.subtitle = message.subtitle;
    }
    if (message.body !== undefined) {
      obj.body = message.body;
    }
    if (message.imageJpeg !== undefined) {
      obj.imageJpeg = base64FromBytes(message.imageJpeg);
    }
    if (message.caption !== undefined) {
      obj.caption = message.caption;
    }
    if (message.footer !== undefined) {
      obj.footer = message.footer;
    }
    if (message.detail !== undefined) {
      obj.detail = message.detail;
    }
    if (message.summary !== undefined) {
      obj.summary = message.summary;
    }
    return obj;
  },

  create(base?: DeepPartial<MiniAppPreview>): MiniAppPreview {
    return MiniAppPreview.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MiniAppPreview>): MiniAppPreview {
    const message = createBaseMiniAppPreview();
    message.title = object.title ?? "";
    message.subtitle = object.subtitle ?? undefined;
    message.body = object.body ?? undefined;
    message.imageJpeg = object.imageJpeg ?? undefined;
    message.caption = object.caption ?? undefined;
    message.footer = object.footer ?? undefined;
    message.detail = object.detail ?? undefined;
    message.summary = object.summary ?? undefined;
    return message;
  },
};

function createBaseMiniAppLayout(): MiniAppLayout {
  return {
    caption: undefined,
    subcaption: undefined,
    trailingCaption: undefined,
    trailingSubcaption: undefined,
    image: undefined,
    imageTitle: undefined,
    imageSubtitle: undefined,
    summary: undefined,
  };
}

export const MiniAppLayout: MessageFns<MiniAppLayout> = {
  encode(message: MiniAppLayout, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.caption !== undefined) {
      writer.uint32(42).string(message.caption);
    }
    if (message.subcaption !== undefined) {
      writer.uint32(26).string(message.subcaption);
    }
    if (message.trailingCaption !== undefined) {
      writer.uint32(50).string(message.trailingCaption);
    }
    if (message.trailingSubcaption !== undefined) {
      writer.uint32(58).string(message.trailingSubcaption);
    }
    if (message.image !== undefined) {
      writer.uint32(34).bytes(message.image);
    }
    if (message.imageTitle !== undefined) {
      writer.uint32(10).string(message.imageTitle);
    }
    if (message.imageSubtitle !== undefined) {
      writer.uint32(18).string(message.imageSubtitle);
    }
    if (message.summary !== undefined) {
      writer.uint32(66).string(message.summary);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MiniAppLayout {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMiniAppLayout();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.caption = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.subcaption = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.trailingCaption = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.trailingSubcaption = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.image = reader.bytes();
          continue;
        }
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.imageTitle = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.imageSubtitle = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.summary = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MiniAppLayout {
    return {
      caption: isSet(object.caption) ? globalThis.String(object.caption) : undefined,
      subcaption: isSet(object.subcaption) ? globalThis.String(object.subcaption) : undefined,
      trailingCaption: isSet(object.trailingCaption)
        ? globalThis.String(object.trailingCaption)
        : isSet(object.trailing_caption)
        ? globalThis.String(object.trailing_caption)
        : undefined,
      trailingSubcaption: isSet(object.trailingSubcaption)
        ? globalThis.String(object.trailingSubcaption)
        : isSet(object.trailing_subcaption)
        ? globalThis.String(object.trailing_subcaption)
        : undefined,
      image: isSet(object.image) ? bytesFromBase64(object.image) : undefined,
      imageTitle: isSet(object.imageTitle)
        ? globalThis.String(object.imageTitle)
        : isSet(object.image_title)
        ? globalThis.String(object.image_title)
        : undefined,
      imageSubtitle: isSet(object.imageSubtitle)
        ? globalThis.String(object.imageSubtitle)
        : isSet(object.image_subtitle)
        ? globalThis.String(object.image_subtitle)
        : undefined,
      summary: isSet(object.summary) ? globalThis.String(object.summary) : undefined,
    };
  },

  toJSON(message: MiniAppLayout): unknown {
    const obj: any = {};
    if (message.caption !== undefined) {
      obj.caption = message.caption;
    }
    if (message.subcaption !== undefined) {
      obj.subcaption = message.subcaption;
    }
    if (message.trailingCaption !== undefined) {
      obj.trailingCaption = message.trailingCaption;
    }
    if (message.trailingSubcaption !== undefined) {
      obj.trailingSubcaption = message.trailingSubcaption;
    }
    if (message.image !== undefined) {
      obj.image = base64FromBytes(message.image);
    }
    if (message.imageTitle !== undefined) {
      obj.imageTitle = message.imageTitle;
    }
    if (message.imageSubtitle !== undefined) {
      obj.imageSubtitle = message.imageSubtitle;
    }
    if (message.summary !== undefined) {
      obj.summary = message.summary;
    }
    return obj;
  },

  create(base?: DeepPartial<MiniAppLayout>): MiniAppLayout {
    return MiniAppLayout.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MiniAppLayout>): MiniAppLayout {
    const message = createBaseMiniAppLayout();
    message.caption = object.caption ?? undefined;
    message.subcaption = object.subcaption ?? undefined;
    message.trailingCaption = object.trailingCaption ?? undefined;
    message.trailingSubcaption = object.trailingSubcaption ?? undefined;
    message.image = object.image ?? undefined;
    message.imageTitle = object.imageTitle ?? undefined;
    message.imageSubtitle = object.imageSubtitle ?? undefined;
    message.summary = object.summary ?? undefined;
    return message;
  },
};

function createBaseSendCustomizedMiniAppMessageRequest(): SendCustomizedMiniAppMessageRequest {
  return {
    chatGuid: "",
    teamId: "",
    extensionBundleId: "",
    appName: "",
    url: "",
    layout: undefined,
    appStoreId: undefined,
    clientMessageId: undefined,
  };
}

export const SendCustomizedMiniAppMessageRequest: MessageFns<SendCustomizedMiniAppMessageRequest> = {
  encode(message: SendCustomizedMiniAppMessageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.teamId !== "") {
      writer.uint32(18).string(message.teamId);
    }
    if (message.extensionBundleId !== "") {
      writer.uint32(26).string(message.extensionBundleId);
    }
    if (message.appName !== "") {
      writer.uint32(34).string(message.appName);
    }
    if (message.url !== "") {
      writer.uint32(42).string(message.url);
    }
    if (message.layout !== undefined) {
      MiniAppLayout.encode(message.layout, writer.uint32(50).fork()).join();
    }
    if (message.appStoreId !== undefined) {
      writer.uint32(56).int64(message.appStoreId);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SendCustomizedMiniAppMessageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSendCustomizedMiniAppMessageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.teamId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.extensionBundleId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.appName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.url = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.layout = MiniAppLayout.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.appStoreId = longToNumber(reader.int64());
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SendCustomizedMiniAppMessageRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      teamId: isSet(object.teamId)
        ? globalThis.String(object.teamId)
        : isSet(object.team_id)
        ? globalThis.String(object.team_id)
        : "",
      extensionBundleId: isSet(object.extensionBundleId)
        ? globalThis.String(object.extensionBundleId)
        : isSet(object.extension_bundle_id)
        ? globalThis.String(object.extension_bundle_id)
        : "",
      appName: isSet(object.appName)
        ? globalThis.String(object.appName)
        : isSet(object.app_name)
        ? globalThis.String(object.app_name)
        : "",
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      layout: isSet(object.layout) ? MiniAppLayout.fromJSON(object.layout) : undefined,
      appStoreId: isSet(object.appStoreId)
        ? globalThis.Number(object.appStoreId)
        : isSet(object.app_store_id)
        ? globalThis.Number(object.app_store_id)
        : undefined,
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: SendCustomizedMiniAppMessageRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.teamId !== "") {
      obj.teamId = message.teamId;
    }
    if (message.extensionBundleId !== "") {
      obj.extensionBundleId = message.extensionBundleId;
    }
    if (message.appName !== "") {
      obj.appName = message.appName;
    }
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.layout !== undefined) {
      obj.layout = MiniAppLayout.toJSON(message.layout);
    }
    if (message.appStoreId !== undefined) {
      obj.appStoreId = Math.round(message.appStoreId);
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<SendCustomizedMiniAppMessageRequest>): SendCustomizedMiniAppMessageRequest {
    return SendCustomizedMiniAppMessageRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SendCustomizedMiniAppMessageRequest>): SendCustomizedMiniAppMessageRequest {
    const message = createBaseSendCustomizedMiniAppMessageRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.teamId = object.teamId ?? "";
    message.extensionBundleId = object.extensionBundleId ?? "";
    message.appName = object.appName ?? "";
    message.url = object.url ?? "";
    message.layout = (object.layout !== undefined && object.layout !== null)
      ? MiniAppLayout.fromPartial(object.layout)
      : undefined;
    message.appStoreId = object.appStoreId ?? undefined;
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseMessageResponse(): MessageResponse {
  return { message: undefined };
}

export const MessageResponse: MessageFns<MessageResponse> = {
  encode(message: MessageResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== undefined) {
      Message.encode(message.message, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MessageResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessageResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = Message.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MessageResponse {
    return { message: isSet(object.message) ? Message.fromJSON(object.message) : undefined };
  },

  toJSON(message: MessageResponse): unknown {
    const obj: any = {};
    if (message.message !== undefined) {
      obj.message = Message.toJSON(message.message);
    }
    return obj;
  },

  create(base?: DeepPartial<MessageResponse>): MessageResponse {
    return MessageResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MessageResponse>): MessageResponse {
    const message = createBaseMessageResponse();
    message.message = (object.message !== undefined && object.message !== null)
      ? Message.fromPartial(object.message)
      : undefined;
    return message;
  },
};

function createBaseEditMessageRequest(): EditMessageRequest {
  return { target: undefined, newText: "", backwardCompatText: undefined, clientMessageId: undefined };
}

export const EditMessageRequest: MessageFns<EditMessageRequest> = {
  encode(message: EditMessageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.target !== undefined) {
      MessageTarget.encode(message.target, writer.uint32(10).fork()).join();
    }
    if (message.newText !== "") {
      writer.uint32(18).string(message.newText);
    }
    if (message.backwardCompatText !== undefined) {
      writer.uint32(26).string(message.backwardCompatText);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EditMessageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditMessageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.target = MessageTarget.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.newText = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.backwardCompatText = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EditMessageRequest {
    return {
      target: isSet(object.target) ? MessageTarget.fromJSON(object.target) : undefined,
      newText: isSet(object.newText)
        ? globalThis.String(object.newText)
        : isSet(object.new_text)
        ? globalThis.String(object.new_text)
        : "",
      backwardCompatText: isSet(object.backwardCompatText)
        ? globalThis.String(object.backwardCompatText)
        : isSet(object.backward_compat_text)
        ? globalThis.String(object.backward_compat_text)
        : undefined,
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: EditMessageRequest): unknown {
    const obj: any = {};
    if (message.target !== undefined) {
      obj.target = MessageTarget.toJSON(message.target);
    }
    if (message.newText !== "") {
      obj.newText = message.newText;
    }
    if (message.backwardCompatText !== undefined) {
      obj.backwardCompatText = message.backwardCompatText;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<EditMessageRequest>): EditMessageRequest {
    return EditMessageRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EditMessageRequest>): EditMessageRequest {
    const message = createBaseEditMessageRequest();
    message.target = (object.target !== undefined && object.target !== null)
      ? MessageTarget.fromPartial(object.target)
      : undefined;
    message.newText = object.newText ?? "";
    message.backwardCompatText = object.backwardCompatText ?? undefined;
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseUnsendMessageRequest(): UnsendMessageRequest {
  return { target: undefined, clientMessageId: undefined };
}

export const UnsendMessageRequest: MessageFns<UnsendMessageRequest> = {
  encode(message: UnsendMessageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.target !== undefined) {
      MessageTarget.encode(message.target, writer.uint32(10).fork()).join();
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UnsendMessageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnsendMessageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.target = MessageTarget.decode(reader, reader.uint32());
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UnsendMessageRequest {
    return {
      target: isSet(object.target) ? MessageTarget.fromJSON(object.target) : undefined,
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: UnsendMessageRequest): unknown {
    const obj: any = {};
    if (message.target !== undefined) {
      obj.target = MessageTarget.toJSON(message.target);
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<UnsendMessageRequest>): UnsendMessageRequest {
    return UnsendMessageRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UnsendMessageRequest>): UnsendMessageRequest {
    const message = createBaseUnsendMessageRequest();
    message.target = (object.target !== undefined && object.target !== null)
      ? MessageTarget.fromPartial(object.target)
      : undefined;
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseSetReactionRequest(): SetReactionRequest {
  return { target: undefined, reaction: undefined, isSet: false, clientMessageId: undefined };
}

export const SetReactionRequest: MessageFns<SetReactionRequest> = {
  encode(message: SetReactionRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.target !== undefined) {
      MessageTarget.encode(message.target, writer.uint32(10).fork()).join();
    }
    if (message.reaction !== undefined) {
      MessageReaction.encode(message.reaction, writer.uint32(18).fork()).join();
    }
    if (message.isSet !== false) {
      writer.uint32(24).bool(message.isSet);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetReactionRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetReactionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.target = MessageTarget.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reaction = MessageReaction.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isSet = reader.bool();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetReactionRequest {
    return {
      target: isSet(object.target) ? MessageTarget.fromJSON(object.target) : undefined,
      reaction: isSet(object.reaction) ? MessageReaction.fromJSON(object.reaction) : undefined,
      isSet: isSet(object.isSet)
        ? globalThis.Boolean(object.isSet)
        : isSet(object.is_set)
        ? globalThis.Boolean(object.is_set)
        : false,
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: SetReactionRequest): unknown {
    const obj: any = {};
    if (message.target !== undefined) {
      obj.target = MessageTarget.toJSON(message.target);
    }
    if (message.reaction !== undefined) {
      obj.reaction = MessageReaction.toJSON(message.reaction);
    }
    if (message.isSet !== false) {
      obj.isSet = message.isSet;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<SetReactionRequest>): SetReactionRequest {
    return SetReactionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetReactionRequest>): SetReactionRequest {
    const message = createBaseSetReactionRequest();
    message.target = (object.target !== undefined && object.target !== null)
      ? MessageTarget.fromPartial(object.target)
      : undefined;
    message.reaction = (object.reaction !== undefined && object.reaction !== null)
      ? MessageReaction.fromPartial(object.reaction)
      : undefined;
    message.isSet = object.isSet ?? false;
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBasePlaceStickerRequest(): PlaceStickerRequest {
  return { target: undefined, sticker: undefined, placement: undefined, clientMessageId: undefined };
}

export const PlaceStickerRequest: MessageFns<PlaceStickerRequest> = {
  encode(message: PlaceStickerRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.target !== undefined) {
      MessageTarget.encode(message.target, writer.uint32(10).fork()).join();
    }
    if (message.sticker !== undefined) {
      AttachmentRef.encode(message.sticker, writer.uint32(18).fork()).join();
    }
    if (message.placement !== undefined) {
      StickerPlacement.encode(message.placement, writer.uint32(26).fork()).join();
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PlaceStickerRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlaceStickerRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.target = MessageTarget.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sticker = AttachmentRef.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.placement = StickerPlacement.decode(reader, reader.uint32());
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlaceStickerRequest {
    return {
      target: isSet(object.target) ? MessageTarget.fromJSON(object.target) : undefined,
      sticker: isSet(object.sticker) ? AttachmentRef.fromJSON(object.sticker) : undefined,
      placement: isSet(object.placement) ? StickerPlacement.fromJSON(object.placement) : undefined,
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: PlaceStickerRequest): unknown {
    const obj: any = {};
    if (message.target !== undefined) {
      obj.target = MessageTarget.toJSON(message.target);
    }
    if (message.sticker !== undefined) {
      obj.sticker = AttachmentRef.toJSON(message.sticker);
    }
    if (message.placement !== undefined) {
      obj.placement = StickerPlacement.toJSON(message.placement);
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<PlaceStickerRequest>): PlaceStickerRequest {
    return PlaceStickerRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PlaceStickerRequest>): PlaceStickerRequest {
    const message = createBasePlaceStickerRequest();
    message.target = (object.target !== undefined && object.target !== null)
      ? MessageTarget.fromPartial(object.target)
      : undefined;
    message.sticker = (object.sticker !== undefined && object.sticker !== null)
      ? AttachmentRef.fromPartial(object.sticker)
      : undefined;
    message.placement = (object.placement !== undefined && object.placement !== null)
      ? StickerPlacement.fromPartial(object.placement)
      : undefined;
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseNotifySilencedMessageRequest(): NotifySilencedMessageRequest {
  return { chatGuid: "", messageGuid: "", clientMessageId: undefined };
}

export const NotifySilencedMessageRequest: MessageFns<NotifySilencedMessageRequest> = {
  encode(message: NotifySilencedMessageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.messageGuid !== "") {
      writer.uint32(18).string(message.messageGuid);
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NotifySilencedMessageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNotifySilencedMessageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messageGuid = reader.string();
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NotifySilencedMessageRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      messageGuid: isSet(object.messageGuid)
        ? globalThis.String(object.messageGuid)
        : isSet(object.message_guid)
        ? globalThis.String(object.message_guid)
        : "",
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: NotifySilencedMessageRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.messageGuid !== "") {
      obj.messageGuid = message.messageGuid;
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<NotifySilencedMessageRequest>): NotifySilencedMessageRequest {
    return NotifySilencedMessageRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<NotifySilencedMessageRequest>): NotifySilencedMessageRequest {
    const message = createBaseNotifySilencedMessageRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.messageGuid = object.messageGuid ?? "";
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseGetMessageRequest(): GetMessageRequest {
  return { messageGuid: "" };
}

export const GetMessageRequest: MessageFns<GetMessageRequest> = {
  encode(message: GetMessageRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.messageGuid !== "") {
      writer.uint32(18).string(message.messageGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMessageRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMessageRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messageGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMessageRequest {
    return {
      messageGuid: isSet(object.messageGuid)
        ? globalThis.String(object.messageGuid)
        : isSet(object.message_guid)
        ? globalThis.String(object.message_guid)
        : "",
    };
  },

  toJSON(message: GetMessageRequest): unknown {
    const obj: any = {};
    if (message.messageGuid !== "") {
      obj.messageGuid = message.messageGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<GetMessageRequest>): GetMessageRequest {
    return GetMessageRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetMessageRequest>): GetMessageRequest {
    const message = createBaseGetMessageRequest();
    message.messageGuid = object.messageGuid ?? "";
    return message;
  },
};

function createBaseGetMessageResponse(): GetMessageResponse {
  return { message: undefined };
}

export const GetMessageResponse: MessageFns<GetMessageResponse> = {
  encode(message: GetMessageResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message !== undefined) {
      Message.encode(message.message, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetMessageResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetMessageResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.message = Message.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetMessageResponse {
    return { message: isSet(object.message) ? Message.fromJSON(object.message) : undefined };
  },

  toJSON(message: GetMessageResponse): unknown {
    const obj: any = {};
    if (message.message !== undefined) {
      obj.message = Message.toJSON(message.message);
    }
    return obj;
  },

  create(base?: DeepPartial<GetMessageResponse>): GetMessageResponse {
    return GetMessageResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetMessageResponse>): GetMessageResponse {
    const message = createBaseGetMessageResponse();
    message.message = (object.message !== undefined && object.message !== null)
      ? Message.fromPartial(object.message)
      : undefined;
    return message;
  },
};

function createBaseListRecentMessagesRequest(): ListRecentMessagesRequest {
  return {
    pageSize: undefined,
    pageToken: undefined,
    isFromMe: undefined,
    isRead: undefined,
    before: undefined,
    after: undefined,
  };
}

export const ListRecentMessagesRequest: MessageFns<ListRecentMessagesRequest> = {
  encode(message: ListRecentMessagesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pageSize !== undefined) {
      writer.uint32(8).int32(message.pageSize);
    }
    if (message.pageToken !== undefined) {
      writer.uint32(18).string(message.pageToken);
    }
    if (message.isFromMe !== undefined) {
      writer.uint32(24).bool(message.isFromMe);
    }
    if (message.isRead !== undefined) {
      writer.uint32(32).bool(message.isRead);
    }
    if (message.before !== undefined) {
      Timestamp.encode(toTimestamp(message.before), writer.uint32(42).fork()).join();
    }
    if (message.after !== undefined) {
      Timestamp.encode(toTimestamp(message.after), writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListRecentMessagesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListRecentMessagesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isFromMe = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isRead = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.before = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.after = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListRecentMessagesRequest {
    return {
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : undefined,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : undefined,
      isFromMe: isSet(object.isFromMe)
        ? globalThis.Boolean(object.isFromMe)
        : isSet(object.is_from_me)
        ? globalThis.Boolean(object.is_from_me)
        : undefined,
      isRead: isSet(object.isRead)
        ? globalThis.Boolean(object.isRead)
        : isSet(object.is_read)
        ? globalThis.Boolean(object.is_read)
        : undefined,
      before: isSet(object.before) ? fromJsonTimestamp(object.before) : undefined,
      after: isSet(object.after) ? fromJsonTimestamp(object.after) : undefined,
    };
  },

  toJSON(message: ListRecentMessagesRequest): unknown {
    const obj: any = {};
    if (message.pageSize !== undefined) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.pageToken !== undefined) {
      obj.pageToken = message.pageToken;
    }
    if (message.isFromMe !== undefined) {
      obj.isFromMe = message.isFromMe;
    }
    if (message.isRead !== undefined) {
      obj.isRead = message.isRead;
    }
    if (message.before !== undefined) {
      obj.before = message.before.toISOString();
    }
    if (message.after !== undefined) {
      obj.after = message.after.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<ListRecentMessagesRequest>): ListRecentMessagesRequest {
    return ListRecentMessagesRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListRecentMessagesRequest>): ListRecentMessagesRequest {
    const message = createBaseListRecentMessagesRequest();
    message.pageSize = object.pageSize ?? undefined;
    message.pageToken = object.pageToken ?? undefined;
    message.isFromMe = object.isFromMe ?? undefined;
    message.isRead = object.isRead ?? undefined;
    message.before = object.before ?? undefined;
    message.after = object.after ?? undefined;
    return message;
  },
};

function createBaseListRecentMessagesResponse(): ListRecentMessagesResponse {
  return { messages: [], nextPageToken: undefined };
}

export const ListRecentMessagesResponse: MessageFns<ListRecentMessagesResponse> = {
  encode(message: ListRecentMessagesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.messages) {
      Message.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.nextPageToken !== undefined) {
      writer.uint32(18).string(message.nextPageToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListRecentMessagesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListRecentMessagesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.messages.push(Message.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListRecentMessagesResponse {
    return {
      messages: globalThis.Array.isArray(object?.messages) ? object.messages.map((e: any) => Message.fromJSON(e)) : [],
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : undefined,
    };
  },

  toJSON(message: ListRecentMessagesResponse): unknown {
    const obj: any = {};
    if (message.messages?.length) {
      obj.messages = message.messages.map((e) => Message.toJSON(e));
    }
    if (message.nextPageToken !== undefined) {
      obj.nextPageToken = message.nextPageToken;
    }
    return obj;
  },

  create(base?: DeepPartial<ListRecentMessagesResponse>): ListRecentMessagesResponse {
    return ListRecentMessagesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListRecentMessagesResponse>): ListRecentMessagesResponse {
    const message = createBaseListRecentMessagesResponse();
    message.messages = object.messages?.map((e) => Message.fromPartial(e)) || [];
    message.nextPageToken = object.nextPageToken ?? undefined;
    return message;
  },
};

function createBaseListChatMessagesRequest(): ListChatMessagesRequest {
  return {
    chatGuid: "",
    pageSize: undefined,
    pageToken: undefined,
    isFromMe: undefined,
    isRead: undefined,
    before: undefined,
    after: undefined,
  };
}

export const ListChatMessagesRequest: MessageFns<ListChatMessagesRequest> = {
  encode(message: ListChatMessagesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.pageSize !== undefined) {
      writer.uint32(16).int32(message.pageSize);
    }
    if (message.pageToken !== undefined) {
      writer.uint32(26).string(message.pageToken);
    }
    if (message.isFromMe !== undefined) {
      writer.uint32(32).bool(message.isFromMe);
    }
    if (message.isRead !== undefined) {
      writer.uint32(40).bool(message.isRead);
    }
    if (message.before !== undefined) {
      Timestamp.encode(toTimestamp(message.before), writer.uint32(50).fork()).join();
    }
    if (message.after !== undefined) {
      Timestamp.encode(toTimestamp(message.after), writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListChatMessagesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListChatMessagesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.isFromMe = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.isRead = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.before = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.after = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListChatMessagesRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : undefined,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : undefined,
      isFromMe: isSet(object.isFromMe)
        ? globalThis.Boolean(object.isFromMe)
        : isSet(object.is_from_me)
        ? globalThis.Boolean(object.is_from_me)
        : undefined,
      isRead: isSet(object.isRead)
        ? globalThis.Boolean(object.isRead)
        : isSet(object.is_read)
        ? globalThis.Boolean(object.is_read)
        : undefined,
      before: isSet(object.before) ? fromJsonTimestamp(object.before) : undefined,
      after: isSet(object.after) ? fromJsonTimestamp(object.after) : undefined,
    };
  },

  toJSON(message: ListChatMessagesRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.pageSize !== undefined) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.pageToken !== undefined) {
      obj.pageToken = message.pageToken;
    }
    if (message.isFromMe !== undefined) {
      obj.isFromMe = message.isFromMe;
    }
    if (message.isRead !== undefined) {
      obj.isRead = message.isRead;
    }
    if (message.before !== undefined) {
      obj.before = message.before.toISOString();
    }
    if (message.after !== undefined) {
      obj.after = message.after.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<ListChatMessagesRequest>): ListChatMessagesRequest {
    return ListChatMessagesRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListChatMessagesRequest>): ListChatMessagesRequest {
    const message = createBaseListChatMessagesRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.pageSize = object.pageSize ?? undefined;
    message.pageToken = object.pageToken ?? undefined;
    message.isFromMe = object.isFromMe ?? undefined;
    message.isRead = object.isRead ?? undefined;
    message.before = object.before ?? undefined;
    message.after = object.after ?? undefined;
    return message;
  },
};

function createBaseListChatMessagesResponse(): ListChatMessagesResponse {
  return { messages: [], nextPageToken: undefined };
}

export const ListChatMessagesResponse: MessageFns<ListChatMessagesResponse> = {
  encode(message: ListChatMessagesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.messages) {
      Message.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.nextPageToken !== undefined) {
      writer.uint32(18).string(message.nextPageToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListChatMessagesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListChatMessagesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.messages.push(Message.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListChatMessagesResponse {
    return {
      messages: globalThis.Array.isArray(object?.messages) ? object.messages.map((e: any) => Message.fromJSON(e)) : [],
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : undefined,
    };
  },

  toJSON(message: ListChatMessagesResponse): unknown {
    const obj: any = {};
    if (message.messages?.length) {
      obj.messages = message.messages.map((e) => Message.toJSON(e));
    }
    if (message.nextPageToken !== undefined) {
      obj.nextPageToken = message.nextPageToken;
    }
    return obj;
  },

  create(base?: DeepPartial<ListChatMessagesResponse>): ListChatMessagesResponse {
    return ListChatMessagesResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListChatMessagesResponse>): ListChatMessagesResponse {
    const message = createBaseListChatMessagesResponse();
    message.messages = object.messages?.map((e) => Message.fromPartial(e)) || [];
    message.nextPageToken = object.nextPageToken ?? undefined;
    return message;
  },
};

function createBaseGetEmbeddedMediaRequest(): GetEmbeddedMediaRequest {
  return { chatGuid: "", messageGuid: "" };
}

export const GetEmbeddedMediaRequest: MessageFns<GetEmbeddedMediaRequest> = {
  encode(message: GetEmbeddedMediaRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.messageGuid !== "") {
      writer.uint32(18).string(message.messageGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetEmbeddedMediaRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetEmbeddedMediaRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messageGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetEmbeddedMediaRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      messageGuid: isSet(object.messageGuid)
        ? globalThis.String(object.messageGuid)
        : isSet(object.message_guid)
        ? globalThis.String(object.message_guid)
        : "",
    };
  },

  toJSON(message: GetEmbeddedMediaRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.messageGuid !== "") {
      obj.messageGuid = message.messageGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<GetEmbeddedMediaRequest>): GetEmbeddedMediaRequest {
    return GetEmbeddedMediaRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetEmbeddedMediaRequest>): GetEmbeddedMediaRequest {
    const message = createBaseGetEmbeddedMediaRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.messageGuid = object.messageGuid ?? "";
    return message;
  },
};

function createBaseGetEmbeddedMediaResponse(): GetEmbeddedMediaResponse {
  return { media: undefined };
}

export const GetEmbeddedMediaResponse: MessageFns<GetEmbeddedMediaResponse> = {
  encode(message: GetEmbeddedMediaResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.media !== undefined) {
      EmbeddedMedia.encode(message.media, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetEmbeddedMediaResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetEmbeddedMediaResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.media = EmbeddedMedia.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetEmbeddedMediaResponse {
    return { media: isSet(object.media) ? EmbeddedMedia.fromJSON(object.media) : undefined };
  },

  toJSON(message: GetEmbeddedMediaResponse): unknown {
    const obj: any = {};
    if (message.media !== undefined) {
      obj.media = EmbeddedMedia.toJSON(message.media);
    }
    return obj;
  },

  create(base?: DeepPartial<GetEmbeddedMediaResponse>): GetEmbeddedMediaResponse {
    return GetEmbeddedMediaResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetEmbeddedMediaResponse>): GetEmbeddedMediaResponse {
    const message = createBaseGetEmbeddedMediaResponse();
    message.media = (object.media !== undefined && object.media !== null)
      ? EmbeddedMedia.fromPartial(object.media)
      : undefined;
    return message;
  },
};

function createBaseSubscribeMessageEventsRequest(): SubscribeMessageEventsRequest {
  return { chatGuid: undefined };
}

export const SubscribeMessageEventsRequest: MessageFns<SubscribeMessageEventsRequest> = {
  encode(message: SubscribeMessageEventsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== undefined) {
      writer.uint32(10).string(message.chatGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscribeMessageEventsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscribeMessageEventsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscribeMessageEventsRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : undefined,
    };
  },

  toJSON(message: SubscribeMessageEventsRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== undefined) {
      obj.chatGuid = message.chatGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<SubscribeMessageEventsRequest>): SubscribeMessageEventsRequest {
    return SubscribeMessageEventsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubscribeMessageEventsRequest>): SubscribeMessageEventsRequest {
    const message = createBaseSubscribeMessageEventsRequest();
    message.chatGuid = object.chatGuid ?? undefined;
    return message;
  },
};

function createBaseSubscribeMessageEventsResponse(): SubscribeMessageEventsResponse {
  return { sequence: undefined, messageChanged: undefined, heartbeat: undefined };
}

export const SubscribeMessageEventsResponse: MessageFns<SubscribeMessageEventsResponse> = {
  encode(message: SubscribeMessageEventsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sequence !== undefined) {
      writer.uint32(8).uint64(message.sequence);
    }
    if (message.messageChanged !== undefined) {
      MessageChangeEvent.encode(message.messageChanged, writer.uint32(82).fork()).join();
    }
    if (message.heartbeat !== undefined) {
      Heartbeat.encode(message.heartbeat, writer.uint32(794).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscribeMessageEventsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscribeMessageEventsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sequence = longToNumber(reader.uint64());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.messageChanged = MessageChangeEvent.decode(reader, reader.uint32());
          continue;
        }
        case 99: {
          if (tag !== 794) {
            break;
          }

          message.heartbeat = Heartbeat.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscribeMessageEventsResponse {
    return {
      sequence: isSet(object.sequence) ? globalThis.Number(object.sequence) : undefined,
      messageChanged: isSet(object.messageChanged)
        ? MessageChangeEvent.fromJSON(object.messageChanged)
        : isSet(object.message_changed)
        ? MessageChangeEvent.fromJSON(object.message_changed)
        : undefined,
      heartbeat: isSet(object.heartbeat) ? Heartbeat.fromJSON(object.heartbeat) : undefined,
    };
  },

  toJSON(message: SubscribeMessageEventsResponse): unknown {
    const obj: any = {};
    if (message.sequence !== undefined) {
      obj.sequence = Math.round(message.sequence);
    }
    if (message.messageChanged !== undefined) {
      obj.messageChanged = MessageChangeEvent.toJSON(message.messageChanged);
    }
    if (message.heartbeat !== undefined) {
      obj.heartbeat = Heartbeat.toJSON(message.heartbeat);
    }
    return obj;
  },

  create(base?: DeepPartial<SubscribeMessageEventsResponse>): SubscribeMessageEventsResponse {
    return SubscribeMessageEventsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubscribeMessageEventsResponse>): SubscribeMessageEventsResponse {
    const message = createBaseSubscribeMessageEventsResponse();
    message.sequence = object.sequence ?? undefined;
    message.messageChanged = (object.messageChanged !== undefined && object.messageChanged !== null)
      ? MessageChangeEvent.fromPartial(object.messageChanged)
      : undefined;
    message.heartbeat = (object.heartbeat !== undefined && object.heartbeat !== null)
      ? Heartbeat.fromPartial(object.heartbeat)
      : undefined;
    return message;
  },
};

/**
 * Sends, mutates, reads, and observes messages.
 *
 * Writes are synchronous to the command path. Methods that return
 * `MessageResponse` also perform the reads needed to return a fresh message
 * snapshot; methods that return `google.protobuf.Empty` do not add a projection
 * read unless their individual contract says so.
 *
 * Durable message changes flow through `SubscribeMessageEvents`. For gap-free
 * reconnect, drain history with `EventService.CatchUpEvents` before joining
 * the live subscription.
 */
export type MessageServiceDefinition = typeof MessageServiceDefinition;
export const MessageServiceDefinition = {
  name: "MessageService",
  fullName: "photon.imessage.v1.MessageService",
  methods: {
    /** Writes */
    sendTextMessage: {
      name: "SendTextMessage",
      requestType: SendTextMessageRequest as typeof SendTextMessageRequest,
      requestStream: false,
      responseType: MessageResponse as typeof MessageResponse,
      responseStream: false,
      options: {},
    },
    sendAttachmentMessage: {
      name: "SendAttachmentMessage",
      requestType: SendAttachmentMessageRequest as typeof SendAttachmentMessageRequest,
      requestStream: false,
      responseType: MessageResponse as typeof MessageResponse,
      responseStream: false,
      options: {},
    },
    sendMultipartMessage: {
      name: "SendMultipartMessage",
      requestType: SendMultipartMessageRequest as typeof SendMultipartMessageRequest,
      requestStream: false,
      responseType: MessageResponse as typeof MessageResponse,
      responseStream: false,
      options: {},
    },
    sendMiniAppMessage: {
      name: "SendMiniAppMessage",
      requestType: SendMiniAppMessageRequest as typeof SendMiniAppMessageRequest,
      requestStream: false,
      responseType: MessageResponse as typeof MessageResponse,
      responseStream: false,
      options: {},
    },
    /** Sends an iMessage mini-app card backed by the caller's own extension. */
    sendCustomizedMiniAppMessage: {
      name: "SendCustomizedMiniAppMessage",
      requestType: SendCustomizedMiniAppMessageRequest as typeof SendCustomizedMiniAppMessageRequest,
      requestStream: false,
      responseType: MessageResponse as typeof MessageResponse,
      responseStream: false,
      options: {},
    },
    editMessage: {
      name: "EditMessage",
      requestType: EditMessageRequest as typeof EditMessageRequest,
      requestStream: false,
      responseType: MessageResponse as typeof MessageResponse,
      responseStream: false,
      options: {},
    },
    /** Retracts an existing message and returns Empty after helper success. */
    unsendMessage: {
      name: "UnsendMessage",
      requestType: UnsendMessageRequest as typeof UnsendMessageRequest,
      requestStream: false,
      responseType: Empty as typeof Empty,
      responseStream: false,
      options: {},
    },
    setReaction: {
      name: "SetReaction",
      requestType: SetReactionRequest as typeof SetReactionRequest,
      requestStream: false,
      responseType: MessageResponse as typeof MessageResponse,
      responseStream: false,
      options: {},
    },
    placeSticker: {
      name: "PlaceSticker",
      requestType: PlaceStickerRequest as typeof PlaceStickerRequest,
      requestStream: false,
      responseType: MessageResponse as typeof MessageResponse,
      responseStream: false,
      options: {},
    },
    /** Triggers Apple's per-message "Notify Anyway" action. */
    notifySilencedMessage: {
      name: "NotifySilencedMessage",
      requestType: NotifySilencedMessageRequest as typeof NotifySilencedMessageRequest,
      requestStream: false,
      responseType: Empty as typeof Empty,
      responseStream: false,
      options: {},
    },
    /** Reads */
    getMessage: {
      name: "GetMessage",
      requestType: GetMessageRequest as typeof GetMessageRequest,
      requestStream: false,
      responseType: GetMessageResponse as typeof GetMessageResponse,
      responseStream: false,
      options: {},
    },
    listRecentMessages: {
      name: "ListRecentMessages",
      requestType: ListRecentMessagesRequest as typeof ListRecentMessagesRequest,
      requestStream: false,
      responseType: ListRecentMessagesResponse as typeof ListRecentMessagesResponse,
      responseStream: false,
      options: {},
    },
    listChatMessages: {
      name: "ListChatMessages",
      requestType: ListChatMessagesRequest as typeof ListChatMessagesRequest,
      requestStream: false,
      responseType: ListChatMessagesResponse as typeof ListChatMessagesResponse,
      responseStream: false,
      options: {},
    },
    getEmbeddedMedia: {
      name: "GetEmbeddedMedia",
      requestType: GetEmbeddedMediaRequest as typeof GetEmbeddedMediaRequest,
      requestStream: false,
      responseType: GetEmbeddedMediaResponse as typeof GetEmbeddedMediaResponse,
      responseStream: false,
      options: {},
    },
    /**
     * Live durable-event subscription. Pair with `EventService.CatchUpEvents`
     * for gap-free history-then-live consumption.
     */
    subscribeMessageEvents: {
      name: "SubscribeMessageEvents",
      requestType: SubscribeMessageEventsRequest as typeof SubscribeMessageEventsRequest,
      requestStream: false,
      responseType: SubscribeMessageEventsResponse as typeof SubscribeMessageEventsResponse,
      responseStream: true,
      options: {},
    },
  },
} as const;

export interface MessageServiceImplementation<CallContextExt = {}> {
  /** Writes */
  sendTextMessage(
    request: SendTextMessageRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<MessageResponse>>;
  sendAttachmentMessage(
    request: SendAttachmentMessageRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<MessageResponse>>;
  sendMultipartMessage(
    request: SendMultipartMessageRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<MessageResponse>>;
  sendMiniAppMessage(
    request: SendMiniAppMessageRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<MessageResponse>>;
  /** Sends an iMessage mini-app card backed by the caller's own extension. */
  sendCustomizedMiniAppMessage(
    request: SendCustomizedMiniAppMessageRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<MessageResponse>>;
  editMessage(
    request: EditMessageRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<MessageResponse>>;
  /** Retracts an existing message and returns Empty after helper success. */
  unsendMessage(request: UnsendMessageRequest, context: CallContext & CallContextExt): Promise<DeepPartial<Empty>>;
  setReaction(
    request: SetReactionRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<MessageResponse>>;
  placeSticker(
    request: PlaceStickerRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<MessageResponse>>;
  /** Triggers Apple's per-message "Notify Anyway" action. */
  notifySilencedMessage(
    request: NotifySilencedMessageRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<Empty>>;
  /** Reads */
  getMessage(
    request: GetMessageRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetMessageResponse>>;
  listRecentMessages(
    request: ListRecentMessagesRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<ListRecentMessagesResponse>>;
  listChatMessages(
    request: ListChatMessagesRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<ListChatMessagesResponse>>;
  getEmbeddedMedia(
    request: GetEmbeddedMediaRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetEmbeddedMediaResponse>>;
  /**
   * Live durable-event subscription. Pair with `EventService.CatchUpEvents`
   * for gap-free history-then-live consumption.
   */
  subscribeMessageEvents(
    request: SubscribeMessageEventsRequest,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<SubscribeMessageEventsResponse>>;
}

export interface MessageServiceClient<CallOptionsExt = {}> {
  /** Writes */
  sendTextMessage(
    request: DeepPartial<SendTextMessageRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<MessageResponse>;
  sendAttachmentMessage(
    request: DeepPartial<SendAttachmentMessageRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<MessageResponse>;
  sendMultipartMessage(
    request: DeepPartial<SendMultipartMessageRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<MessageResponse>;
  sendMiniAppMessage(
    request: DeepPartial<SendMiniAppMessageRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<MessageResponse>;
  /** Sends an iMessage mini-app card backed by the caller's own extension. */
  sendCustomizedMiniAppMessage(
    request: DeepPartial<SendCustomizedMiniAppMessageRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<MessageResponse>;
  editMessage(
    request: DeepPartial<EditMessageRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<MessageResponse>;
  /** Retracts an existing message and returns Empty after helper success. */
  unsendMessage(request: DeepPartial<UnsendMessageRequest>, options?: CallOptions & CallOptionsExt): Promise<Empty>;
  setReaction(
    request: DeepPartial<SetReactionRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<MessageResponse>;
  placeSticker(
    request: DeepPartial<PlaceStickerRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<MessageResponse>;
  /** Triggers Apple's per-message "Notify Anyway" action. */
  notifySilencedMessage(
    request: DeepPartial<NotifySilencedMessageRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<Empty>;
  /** Reads */
  getMessage(
    request: DeepPartial<GetMessageRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetMessageResponse>;
  listRecentMessages(
    request: DeepPartial<ListRecentMessagesRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<ListRecentMessagesResponse>;
  listChatMessages(
    request: DeepPartial<ListChatMessagesRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<ListChatMessagesResponse>;
  getEmbeddedMedia(
    request: DeepPartial<GetEmbeddedMediaRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetEmbeddedMediaResponse>;
  /**
   * Live durable-event subscription. Pair with `EventService.CatchUpEvents`
   * for gap-free history-then-live consumption.
   */
  subscribeMessageEvents(
    request: DeepPartial<SubscribeMessageEventsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): AsyncIterable<SubscribeMessageEventsResponse>;
}

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from((globalThis as any).Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return (globalThis as any).Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export type ServerStreamingMethodResult<Response> = { [Symbol.asyncIterator](): AsyncIterator<Response, void> };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
